import { render, staticRenderFns } from "./printOf.vue?vue&type=template&id=1bf31a33&scoped=true&lang=html&"
import script from "./printOf.vue?vue&type=script&lang=js&"
export * from "./printOf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf31a33",
  null
  
)

export default component.exports